import { C8Node } from "csi/typings";

export function nodeHasAttribute(node: C8Node, id: string): boolean {
	return node ? (node[id] !== undefined) : false;
}
